<template>
  <OnboardingWelcomePage />
</template>

<script setup lang="ts">
import OnboardingWelcomePage from "shared-ui/pages/OnboardingWelcomePage.vue";

definePage({
  meta: {
    requiresAuth: true,
  },
});
</script>
